// ─────────────────────────────────────────────────────────────────────────────
// useCountUp — animates a number from 0 → target over `duration` ms.
// Extracted from Dashboard.js and fixed: cancels its requestAnimationFrame on
// unmount / target change (the original leaked RAF callbacks).
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useRef, useState } from "react";

export function useCountUp(target, duration = 1200) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    let start = null;
    const step = (ts) => {
      if (start === null) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      setValue(Math.floor(progress * target));
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [target, duration]);

  return value;
}

export default useCountUp;
